
import { defineComponent, reactive } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { ConfigService } from '@/services/config.service'

export default defineComponent({
  name: 'LogoffHeader',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  setup() {
    const injector = useReflectiveInjector()
    const config = injector.get(ConfigService as Type<ConfigService>)

    const viewModel = reactive({
      logo: config.getLogo,
      title: config.getTitle,
    })

    function clickClose() {
      window.close()
    }

    return {
      viewModel,
      clickClose
    }
  }
})
